"use client";

import { captureClientEvent } from "@/lib/analytics/client";

/** Explicit allowlist: never send form values, client secrets, URLs, or provider bodies. */
interface CheckoutDiagnostics {
    provider: "stripe" | "paypal";
    pack_id?: string;
    purchase_id?: string;
    paypal_purchase_id?: string;
    attempt_id?: string;
    outcome?: string;
    reason?: string;
    payment_method?: "card" | "link" | "paypal" | "express";
    error_code?: string;
}
export function checkoutEvent(event: string, diagnostics: CheckoutDiagnostics) {
    try { captureClientEvent(event, { domain: "payments", source: "checkout_browser", ...diagnostics }); }
    catch { /* Telemetry must never prevent checkout or navigation. */ }
}
